import React from 'react';

import { Button } from '@lightspeed/unified-components-default-consumer-theme/react';
import { T } from '@transifex/react';
import { useFormContext } from 'react-hook-form';

import { ContactDetailsSection } from '../../../reservation/components/reservation-form/contact-info-step/contact-details-section';
import type { ReservationFormData } from '../../../reservation/types';
import { BusinessLocation } from '../../../shared/types';

import { StickyFooter } from './sticky-footer';

interface ContactInfoStepProps {
  businessLocation: BusinessLocation;
  onNext: () => void;
}

export function ContactInfoStep({ businessLocation, onNext }: ContactInfoStepProps) {
  const { trigger } = useFormContext<ReservationFormData>();

  const handleNext = async () => {
    const isValid = await trigger([
      'guest.firstName',
      'guest.lastName',
      'guest.email',
      'guest.phone',
    ]);
    if (isValid) {
      onNext();
    }
  };

  return (
    <>
      <div className="px-4 py-3">
        <ContactDetailsSection businessLocation={businessLocation} />
      </div>

      <StickyFooter>
        <Button
          type="button"
          size="large"
          block
          onClick={handleNext}
          customDataAttributes={{ root: { testid: 'contact-info-next-button' } }}
        >
          <T
            _str="Continue to confirmation"
            _context="Continue to confirmation step button"
            _tags="widget,reservation"
            _key="Widget.ContactInfo.Continue.button"
          />
        </Button>
      </StickyFooter>
    </>
  );
}
